import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchManualPreadviceTransactionsApply from '../../api/ManualPreadviceTransactionsApplyAPI';
import { MPA_TRANSACTIONS_APPLY_REQUEST } from '../actions/types/ManualPreadviceTransactionsApplyActionsTypes';
import {
  postManualPreadviceTransactionsApplySuccessActionCreator,
  postManualPreadviceTransactionsApplyFailureActionCreator,
} from '../actions/ManualPreadviceTransactionsApplyActions';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';

function* doMpaTransactionsApplyWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchManualPreadviceTransactionsApply, action.payload);
    yield put(postManualPreadviceTransactionsApplySuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.manualpreadvicetransactions.apply.success'),
    }));
  } catch (error) {
    yield put(postManualPreadviceTransactionsApplyFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doMpaTransactionsApplyWatcher() {
  yield takeLatest(MPA_TRANSACTIONS_APPLY_REQUEST, doMpaTransactionsApplyWorker);
}

export default doMpaTransactionsApplyWatcher;
